import { useEffect, useState } from "react";
import { Popover } from "antd";

import { Input } from "antd";
import axios from "axios";
import moment from "moment";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { SPOTIFY_TOKEN } from "../../constants/storage";
import { useLoginContext } from "../../context";
import { usePlaylistContext } from "../../context/PlaylistContext";
import {
  addItemToStorage,
  addSongToPlaylist,
  getPlaylistItemsSpotify,
  getRefreshedToken,
  isSpotifyTrackURI,
} from "../../utils";
import { useAccountCampaignAccept } from "../../hooks/useAccountCampaignAccept";
import type { LinkedCuratorProfile } from "../../utils/accountCuratorOffer";
import { getSiblingProfileObjectIdForAdd } from "../../utils/authAccount";
import {
  buildInstantShareDetail,
  formatPlaylistAddError,
  isPastStartTime,
  PAST_START_TIME_MESSAGE,
  persistInstantShareDetail,
  validateAddToPlaylistForm,
} from "../../utils/addToPlaylistForm";
import DatePicker from "../DatePicker/DatePickerWithoutFormik";
import PlanToast from "../PlanToast/PlanToast";
import Spinner from "../Spinner/Spinner";
import { AddToPlayListModalStyle } from "./AddToPlayListModal.style";
import InstantShareModal from "../ShareModal/InstantShareModal";

const EMPTY_LINKED_PROFILES: LinkedCuratorProfile[] = [];

// Helper function to validate Spotify URL
const isSpotifyURL = (url: string): boolean => {
  if (!url) return false;
  try {
    const urlPattern = /^https:\/\/open\.spotify\.com\/track\/[a-zA-Z0-9]+(\?.*)?$/;
    return urlPattern.test(url);
  } catch {
    return false;
  }
};

// Helper function to convert Spotify URL to URI
const convertURLtoURI = (url: string): string => {
  try {
    const match = url.match(/https:\/\/open\.spotify\.com\/track\/([a-zA-Z0-9]+)/);
    if (match && match[1]) {
      return `spotify:track:${match[1]}`;
    }
    return url;
  } catch {
    return url;
  }
};

interface AddToPlayListModalProps {
  isModalVisible?: boolean;
  hideUriInput?: boolean;
  preRelease?: boolean;
  hideRadioButtons?: boolean;
  setIsModalVisible?: (_: boolean) => void;
  songURI?: string;
  setSongURI?: (_: string) => void;
  existSongUri?: string;
  dataSearched?: any;
  linkedProfiles?: LinkedCuratorProfile[];
  accountUserId?: string;
}

const AddToPlayListModalSearch = (props: AddToPlayListModalProps) => {
  const {
    isModalVisible,
    setIsModalVisible,
    hideRadioButtons,
    hideUriInput,
    preRelease,
    dataSearched,
    linkedProfiles = EMPTY_LINKED_PROFILES,
    accountUserId,
  } = props;
  const [setLoading, showLoading] = useState(false);
  const user = JSON.parse(localStorage.getItem("userInfo"));
  const [limitText, setLimitText] = useState("");
  const [enableDatePicker, setEnableDatePicker] = useState(true);
  const dispatch = useDispatch();
  const [searchPlaylistText, setSearchPlaylistText] = useState('')
  const { state } = usePlaylistContext();
  const { state: loginState, dispatch: loginDispatch } = useLoginContext();
  const [arrayPositions, setArrayPositions] = useState([])
  const [positionText, setPositionText] = useState(0)
  const [setButtom, showButtom] = useState("");
  const [setDate, showDate] = useState(null);
  const [release, setRelease] = useState("Immediately");
  const [selectPlayListOpen, setSelectPlayListOpen] = useState(false);
  const [selectedPlayList, setSelectedPlayList] = useState([]);
  const [totalPlaylist, setTotalPlaylist] = useState([]);
  const [totalPlaylistNumber, setTotalPlaylistNumber] = useState(0);
  const [note, setNote] = useState("");
  const [instantShareSongModal, setInstantShareSongModal] = useState(false);

  const [data, setData] = useState({
    playlistId: [],
    startTime: "",
    endTime: "",
    position: 1,
    status: "past",
    searchedSongData: "",
  });
  const [inputType, setInputType] = useState<"uri" | "url">("uri");

  // Phase 3: Song preview state
  const [songPreview, setSongPreview] = useState(null);

  const {
    addCampaignSongToSelectedPlaylists,
    getPlaylistSession,
    isAccountPlaylistPickerLoading,
    mapCampaignPlaylistItems,
    resetCampaignAcceptState,
    usesAccountWidePlaylists,
    usesMultiProfilePlaylistMode,
    activeProfileId,
  } = useAccountCampaignAccept({
    isModalVisible,
    isFromCampaign: false,
    linkedProfiles,
    accountUserId,
    loginState,
    release,
    setDate,
    note,
    userName: user?.name,
    totalPlaylist,
    setLoading: showLoading,
  });

  const resolvePlaylistAuth = (targetPlaylistId: string) => {
    const session = getPlaylistSession(targetPlaylistId);
    const profileObjectId = getSiblingProfileObjectIdForAdd(
      session?.profileId,
      activeProfileId
    );
    return {
      accessToken: session?.accessToken || loginState.token,
      refreshToken: profileObjectId ? '_' : loginState.refreshToken,
      spotifyUserId: session?.spotifyUserId || loginState.userId,
      profileObjectId,
    };
  };

  const handleOk = () => {
    setIsModalVisible(false);
    setSearchPlaylistText('');
    setSelectPlayListOpen(false);
    setSelectedPlayList([]);
    setArrayPositions([]);
    setPositionText(0);
    setData(prev => ({
      ...prev,
      playlistId: [],
      startTime: '',
      endTime: '',
      position: 1,
      status: 'past',
    }));
    resetCampaignAcceptState();
  };

  const onHandle = (date, dateString) => {
    if (date) {
      showDate(date instanceof Date ? date : new Date(date));
    }
    // showButtom("");
  };

  const handleSwitch = (value) => {
    setEnableDatePicker(!enableDatePicker);
    if (value === true) {
      showButtom("disabled");
    } else {
      showButtom("");
    }
  };

  const handleCancel = (e: any) => {
    e.stopPropagation();
    // setSelectedPlayList([id])
    setData({
      playlistId: [],
      startTime: "",
      endTime: "",
      position: 1,
      status: "past",
      searchedSongData: "",
    });
    setNote("");
    setSelectedPlayList([]);
    setIsModalVisible(false);
    setSearchPlaylistText('')
    setSelectPlayListOpen(false);
    setArrayPositions([])
    resetCampaignAcceptState();
  };

  const addToPlaylistLoop = async () => {
    if (isAccountPlaylistPickerLoading) {
      return;
    }

    showLoading(true);

    let songData = data.searchedSongData || dataSearched?.songUri;
    if (inputType === "url") {
      if (!isSpotifyURL(songData)) {
        toast.error("Please enter a valid Spotify URL");
        showLoading(false);
        return;
      }
      songData = convertURLtoURI(songData);
    }

    if (!isSpotifyTrackURI(songData)) {
      toast.error("URI is incorrect");
      showLoading(false);
      return;
    }

    const playlistIds = Array.isArray(data.playlistId) ? data.playlistId : [data.playlistId];
    const usesNumberPositionInput = selectedPlayList.length > 1 || playlistIds.length > 1;
    const validation = validateAddToPlaylistForm({
      playlistIds,
      position: data.position,
      arrayPositions,
      usesNumberPositionInput,
      searchedSongData: songData,
    });

    if (validation.ok === false) {
      toast.error(validation.message);
      showLoading(false);
      return;
    }

    if (preRelease && isPastStartTime(setDate)) {
      toast.error(PAST_START_TIME_MESSAGE);
      showLoading(false);
      return;
    }

    const updatedData = {
      ...data,
      searchedSongData: songData,
      position: validation.position,
    };
    setData(updatedData);

    if (usesAccountWidePlaylists) {
      const firstPlacement = await addCampaignSongToSelectedPlaylists({
        ...updatedData,
        playlistId: playlistIds.length === 1 ? playlistIds[0] : playlistIds,
        artist_name: dataSearched?.artistName,
        song_name: dataSearched?.songName,
      });
      if (firstPlacement) {
        dispatch({
          type: "SET_SEARCHED_SONG_DATA",
          payload: dataSearched.songUri,
        });
        persistInstantShareDetail(
          buildInstantShareDetail({
            songUri: firstPlacement.songURI || dataSearched.songUri,
            playlistId: firstPlacement.playlistId,
            position: firstPlacement.songPosition,
            startTime: firstPlacement.startTime,
            scheduleDate: setDate,
            endTime: firstPlacement.endTime || updatedData.endTime,
          })
        );
        showLoading(false);
        handleOk();
        openInstantModal();
      }
      return;
    }

    if (playlistIds.length > 1) {
      playlistIds.forEach((playlistItemId, index) => {
        getPlaylistItemsSpotify(playlistItemId, resolvePlaylistAuth(playlistItemId).accessToken)
          .then(res => {
            if (res.total === 0) {
              handleAddSong(
                playlistItemId,
                {
                  ...updatedData,
                  position: 0,
                  playlistId: playlistItemId,
                  status: release === "Later" ? "future" : "past",
                },
                dataSearched,
                playlistIds.length - 1 === index
              );
            } else if (updatedData.position > res.total) {
              handleAddSong(
                playlistItemId,
                {
                  ...updatedData,
                  position: res.total + 1,
                  playlistId: playlistItemId,
                  status: release === "Later" ? "future" : "past",
                },
                dataSearched,
                playlistIds.length - 1 === index
              );
            } else {
              handleAddSong(
                playlistItemId,
                {
                  ...updatedData,
                  playlistId: playlistItemId,
                  status: release === "Later" ? "future" : "past",
                },
                dataSearched,
                playlistIds.length - 1 === index
              );
            }
          })
          .catch(error => {
            console.error("Failed to load playlist items:", error);
            toast.error(formatPlaylistAddError(error, "Could not load playlist details from Spotify."));
            if (playlistIds.length - 1 === index) {
              showLoading(false);
            }
          });
      });
      return;
    }

    validation.positions.forEach((positionValue, index) => {
      getPlaylistItemsSpotify(playlistIds[0], resolvePlaylistAuth(playlistIds[0]).accessToken)
        .then(res => {
          if (res.total === 0) {
            handleAddSong(
              playlistIds[0],
              {
                ...updatedData,
                position: index + 1,
                playlistId: playlistIds[0],
                status: release === "Later" ? "future" : "past",
              },
              dataSearched,
              validation.positions.length - 1 === index
            );
          } else if (Number(positionValue) > res.total) {
            handleAddSong(
              playlistIds[0],
              {
                ...updatedData,
                position: res.total + 1,
                playlistId: playlistIds[0],
                status: release === "Later" ? "future" : "past",
              },
              dataSearched,
              validation.positions.length - 1 === index
            );
          } else {
            handleAddSong(
              playlistIds[0],
              {
                ...updatedData,
                position: positionValue,
                playlistId: playlistIds[0],
                status: release === "Later" ? "future" : "past",
              },
              dataSearched,
              validation.positions.length - 1 === index
            );
          }
        })
        .catch(error => {
          console.error("Failed to load playlist items:", error);
          toast.error(formatPlaylistAddError(error, "Could not load playlist details from Spotify."));
          if (validation.positions.length - 1 === index) {
            showLoading(false);
          }
        });
    });
  };

  const handleAddSong = (playlistId, values, selectedSong, lastValue) => {
    dispatch({
      type: "SET_SEARCHED_SONG_DATA",
      payload: selectedSong.songUri,
    });

    const targetPlaylistId = Array.isArray(playlistId) ? playlistId[0] : playlistId;
    const playlistAuth = resolvePlaylistAuth(targetPlaylistId);
    const positionCheck = validateAddToPlaylistForm({
      playlistIds: [targetPlaylistId],
      position: values.position,
      usesNumberPositionInput: true,
      searchedSongData: selectedSong.songUri,
    });

    if (positionCheck.ok === false) {
      toast.error(positionCheck.message);
      if (lastValue) {
        showLoading(false);
      }
      return;
    }

    addSongToPlaylist(
      Array.isArray(playlistId) ? playlistId : [playlistId],
      selectedSong.songUri,
      playlistAuth.accessToken,
      playlistAuth.refreshToken,
      playlistAuth.spotifyUserId,
      positionCheck.position,
      setDate,
      values.endTime,
      values.status,
      note,
      undefined,
      selectedSong?.artistName,
      selectedSong?.songName,
      playlistAuth.profileObjectId
    )
      .then(async (response) => {
        if (lastValue) {
          const obj = buildInstantShareDetail({
            songUri: data.searchedSongData,
            playlistId: Array.isArray(playlistId) ? playlistId[0] : playlistId,
            position: values.position,
            startTime: data.startTime,
            scheduleDate: setDate,
            endTime: data.endTime,
          });
          persistInstantShareDetail(obj);
          showLoading(false);
          setSelectedPlayList([]);
          setArrayPositions([])
          setPositionText(0)
          setNote("");
          setData({
            playlistId: [],
            startTime: "",
            endTime: "",
            position: 1,
            status: "past",
            searchedSongData: "",
          });
          setIsModalVisible(false);
          openInstantModal()
          // window.location.reload()
        }
      })
      .catch(error => {
        toast.error(formatPlaylistAddError(error));
        if (lastValue) {
          showLoading(false);
        }
      });
  };

  /**
   * This function is filtering the playlists for dropdown based on owner
   * because we want the dropdown to show only those playlists scheduled by
   * songplace
   *
   * @returns {playlist[]} filtered playlists
   */
  const getPlaylistItems = (playlists) => mapCampaignPlaylistItems(playlists);

  const getPlaylists = (offset) => {
    axios(`https://api.spotify.com/v1/me/playlists?limit=50&offset=${offset}`, {
      method: "GET",
      headers: { Authorization: "Bearer " + loginState.token },
    })
      .then((genreResponse) => {
        setTotalPlaylist([...totalPlaylist, ...genreResponse?.data.items]);
        if (totalPlaylistNumber < genreResponse?.data.total) {
          setTotalPlaylistNumber(genreResponse?.data.total);
        }
      })
      .catch(async (error) => {
        if (
          error.response?.data?.error?.status === 401 ||
          error.response?.status === 400
        ) {
          getRefreshedToken(state.refreshToken)
            .then((response) => {
              addItemToStorage(SPOTIFY_TOKEN, response?.data?.access_token);

              loginDispatch({
                type: "ADD_TOKEN",
                payload: response?.data?.access_token,
              });
            })
            .catch(() => { });
        }
      });
  };
  // const [offset,setOffset] = useState(0)
  useEffect(() => {
    if (!isModalVisible) {
      return;
    }

    setSelectedPlayList([]);
    setArrayPositions([]);
    setPositionText(0);
    setData(prev => ({
      ...prev,
      playlistId: [],
      startTime: '',
      endTime: '',
      position: 1,
      status: 'past',
    }));
  }, [isModalVisible, dataSearched?.songUri]);

  useEffect(() => {
    if (usesMultiProfilePlaylistMode || isAccountPlaylistPickerLoading) {
      return;
    }
    if (
      isModalVisible &&
      (totalPlaylist.length < totalPlaylistNumber || totalPlaylist.length === 0)
    ) {
      getPlaylists(totalPlaylist.length);
    }
  }, [
    isModalVisible,
    totalPlaylistNumber,
    totalPlaylist,
    usesMultiProfilePlaylistMode,
    isAccountPlaylistPickerLoading,
  ]);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (preRelease) {
      setRelease("Later");
      handleSwitch(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preRelease]);
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    setData({
      ...data,
      searchedSongData: props.songURI,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.songURI]);

  // Phase 3: Fetch song details when modal opens with search data
  useEffect(() => {
    if (isModalVisible && dataSearched && dataSearched.songUri) {
      // Extract track ID from URI
      const trackId = dataSearched.songUri.split(':')[2];
      if (!trackId) return;

      axios
        .get(`https://api.spotify.com/v1/tracks/${trackId}`, {
          headers: {
            Authorization: `Bearer ${loginState.token}`,
          },
        })
        .then((response) => {
          setSongPreview(response.data);
        })
        .catch(async (error) => {
          setSongPreview(null);
          // Handle token refresh if needed
          if (error.response?.status === 401) {
            try {
              const refreshResponse = await getRefreshedToken(loginState.refreshToken);
              // Try again with refreshed token
              axios
                .get(`https://api.spotify.com/v1/tracks/${trackId}`, {
                  headers: {
                    Authorization: `Bearer ${refreshResponse?.data?.access_token}`,
                  },
                })
                .then((response) => {
                  setSongPreview(response.data);
                })
                .catch(() => {
                  // Silent fail
                });
            } catch (refreshError) {
              // Silent fail
            }
          }
        });
    } else {
      setSongPreview(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalVisible, dataSearched]);

  const openInstantModal = () => {
    let instantShareDetail = JSON.parse(localStorage.getItem('instantShareDetail'))
    if (instantShareDetail) {
      setInstantShareSongModal(true)
    }
  }
  return (
    <>
      <AddToPlayListModalStyle
        visible={isModalVisible}
        onOk={handleOk}
        footer={null}
        onCancel={handleCancel}
      >
        <div
          onClick={() => {
            setSelectPlayListOpen(false);
          }}
        >
          <div className="addToPlaylistHead">
            <h1 className="heading">Add to playlist</h1>
            <p className="description" onClick={() => {
              //console.log(selectedPlayList, 'selectedPlayList')
            }}>
              To schedule a song in your playlist, please select the playlist
              below.
            </p>
          </div>
          
          {/* Phase 3: Display song details from search results */}
          {songPreview && (
            <div style={{ marginTop: '15px', marginBottom: '15px', padding: '12px', borderRadius: '8px', border: '1px solid #333' }}>
              <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                {songPreview.album?.images?.[2]?.url && (
                  <img
                    src={songPreview.album.images[2].url}
                    alt="Album cover"
                    style={{ width: '64px', height: '64px', borderRadius: '4px' }}
                  />
                )}
                <div style={{ flex: 1 }}>
                  <div style={{ color: '#fff', fontWeight: '500', marginBottom: '4px' }}>
                    {songPreview.name}
                  </div>
                  <div style={{ color: '#999', fontSize: '14px' }}>
                    {songPreview.artists?.map(a => a.name).join(', ')}
                  </div>
                  {songPreview.album?.name && (
                    <div style={{ color: '#666', fontSize: '13px', marginTop: '2px' }}>
                      {songPreview.album.name}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
          <div className="formAddToPlaylist">
            <div className="formPlaylist">
              <div className="playlistPosition">
                <label className="label">
                  <p>Playlists</p>
                  <p className="limitText">{limitText}</p>
                  <div
                    className="playlistInput"
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectPlayListOpen(true);
                    }}
                  // onBlur={() => {
                  //   setSelectPlayListOpen(false);
                  // }}
                  >
                    <div className="playlistInputText">
                      {selectedPlayList.map((a, i) => (
                        <span>{a}</span>
                      ))}
                      <input className="playlistInputTextSearch" value={searchPlaylistText} placeholder="Search Playlist" onChange={(ev) => {
                        setSearchPlaylistText(ev.target.value)
                      }} />
                    </div>
                    <div
                      className={`optionsList ${selectPlayListOpen ? "active" : ""
                        }`}
                    >
                      {isAccountPlaylistPickerLoading ? (
                        <div className="optionName">
                          <div className="optionText">
                            <p>Loading playlists from your linked profiles...</p>
                          </div>
                        </div>
                      ) : getPlaylistItems(totalPlaylist).map(
                        (option: {
                          key: string;
                          value: string;
                          disabled?: boolean;
                        }) => {
                          return option?.value?.toLowerCase().includes(searchPlaylistText?.toLowerCase()) ? (
                            <div
                              className="optionName"
                              id="add-songs-mode-options"
                              onClick={(value) => {
                                value.stopPropagation();
                                if (data.playlistId.includes(option.key)) {
                                  setLimitText("");
                                  let obj = { ...data };
                                  obj.playlistId.splice(
                                    obj.playlistId.indexOf(option.key),
                                    1
                                  );
                                  // @ts-ignore
                                  setData(obj);
                                  let playlist = [...selectedPlayList];
                                  playlist.splice(
                                    playlist.indexOf(option.value),
                                    1
                                  );
                                  setSelectedPlayList([...playlist]);
                                } else {
                                  if (
                                    user?.free &&
                                    data?.playlistId.length >= 1
                                  ) {
                                    setLimitText(
                                      "Upgrade your plan to select multiple playlists"
                                    );
                                  } else {
                                    setLimitText("");
                                    let obj = { ...data };
                                    // @ts-ignore
                                    obj.playlistId = [
                                      ...obj.playlistId,
                                      option.key,
                                    ];
                                    setData(obj);
                                    let playlist = [...selectedPlayList];
                                    playlist = [...playlist, option.value];
                                    setSelectedPlayList([...playlist]);
                                  }
                                }
                              }}
                            >
                              <div className="optionText">
                                <p>{option.value}</p>
                                <div
                                  className={`optionMark ${data.playlistId.includes(option.key)
                                    ? "active"
                                    : ""
                                    }`}
                                >
                                  <svg
                                    width="13"
                                    height="10"
                                    viewBox="0 0 13 10"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M1.5 5.5L5 9L12 1.5"
                                      stroke="white"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          ) : null;
                        }
                      )}
                    </div>
                  </div>
                </label>
                <label className="label">
                  <p>Position of the song in playlist</p>

                  {selectedPlayList.length > 1 ?
                    <Input
                      type="number"
                      style={{ border: 'none', padding: '7.5px 10px' }}
                      min={1}
                      bordered={false}
                      value={data.position}
                      placeholder="Position of the song in playlist"
                      onChange={(value) => {
                        let obj = { ...data };
                        obj.position = Number(value.target.value);
                        setData(obj);
                      }}
                    />
                    :
                    <>
                      <Popover content={<p>Use space or enter to add multiple positions</p>} placement="bottomLeft">
                        <div
                          className="playlistInput">
                          <div className="playlistInputText">
                            {arrayPositions.map((a, i) => (
                              <span>{a}</span>
                            ))}
                            <Input
                              type="number"
                              min={1}
                              bordered={false}
                              value={positionText === 0 ? 'Please enter position' : positionText}
                              placeholder="Position of the song in playlist"
                              onChange={(value) => {
                                setPositionText(Number(value.target.value))
                              }}
                              onBlur={(ev) => {
                                if (ev.currentTarget.value) {

                                  let arr = [...arrayPositions, ev.currentTarget.value]
                                  //console.log(arr)
                                  setArrayPositions(arr)
                                  setPositionText(0)
                                }
                              }}
                              onKeyDown={(ev) => {
                                if (ev.keyCode === 13 || ev.keyCode === 32) {
                                  if (ev.currentTarget.value) {
                                    let arr = [...arrayPositions, ev.currentTarget.value]
                                    //console.log(arr)
                                    setArrayPositions(arr)
                                    setPositionText(0)
                                  }
                                } else if (ev.keyCode === 8) {
                                  if (!ev.currentTarget.value) {

                                    let arr = [...arrayPositions]
                                    arr.pop()
                                    setArrayPositions(arr)
                                    setPositionText(0)
                                  }
                                }
                              }}
                            />
                          </div>
                        </div>
                      </Popover>
                    </>



                  }

                </label>
              </div>
              {hideUriInput ? null : (
                <>
                  <div className="release">
                    <label
                      onClick={() => {
                        setInputType("uri");
                      }}
                    >
                      <div className="radioCheck">
                        {inputType === "uri" ? <div></div> : null}
                      </div>
                      URI
                    </label>
                    <label
                      onClick={() => {
                        setInputType("url");
                      }}
                    >
                      <div className="radioCheck">
                        {inputType === "url" ? <div></div> : null}
                      </div>
                      URL
                    </label>
                  </div>
                  <label className="label">
                    <p>Song {inputType === "uri" ? "URI" : "URL"}</p>
                    <Input
                      // type="text"
                      placeholder={inputType === "uri" ? "Song URI" : "Song URL"}
                      value={data.searchedSongData}
                      onChange={(value: any) => {
                        let obj = { ...data };
                        obj.searchedSongData = value.target.value;
                        setData(obj);
                      }}
                    />
                  </label>
                </>
              )}
              {hideRadioButtons ? null : (
                <div className="release">
                  <PlanToast
                    available={["pro", "unlimited"]}
                    titleHeading={"Schedule Start date"}
                  >
                    <label
                      onClick={() => {
                        setRelease("Immediately");
                        handleSwitch(false);
                        let obj = { ...data };
                        obj.startTime = "";
                        obj.endTime = ""
                        setData(obj);
                      }}
                    >
                      <div className="radioCheck">
                        {release === "Immediately" ? <div></div> : null}
                      </div>
                      Immediately
                    </label>
                    <label
                      onClick={() => {
                        setRelease("Later");
                        handleSwitch(true);
                        let obj = { ...data };
                        obj.startTime = "";
                        obj.endTime = ""
                        setData(obj);
                      }}
                    >
                      <div className="radioCheck">
                        {release === "Later" ? <div></div> : null}
                      </div>
                      Later
                    </label>
                  </PlanToast>
                </div>
              )}
              <div
                className="playlistPosition"
                style={{ marginTop: preRelease ? "20px" : "auto" }}
              >
                {setButtom ? (
                  <label className="label">
                    <p>Start date</p>
                    <DatePicker
                      showNow={false}
                      defaultValue={moment()}
                      type="datetime-local"
                      value={data.startTime ? moment(data.startTime) : moment()}
                      format={"DD/MM/YYYY hh:mm A"}
                      onChange={(value, valueDate) => {
                        if (isPastStartTime(value)) {
                          toast.error(PAST_START_TIME_MESSAGE);
                          return;
                        }
                        onHandle(value, valueDate);
                        let obj = { ...data };
                        obj.startTime = value ? value.toISOString() : undefined;
                        setData(obj);
                      }}
                      // Disable past dates
                      disabledDate={(current) => {
                        return current && current < moment().startOf('day');
                      }}
                      // Disable past times if the selected date is today
                      disabledTime={(current) => {
                        const now = moment();
                        if (current && current.isSame(now, 'day')) {
                          return {
                            disabledHours: () => Array.from({ length: now.hours() }, (_, i) => i),
                            disabledMinutes: () => {
                              // Disable all past minutes in the current hour
                              if (current.hours() === now.hours()) {
                                return Array.from({ length: now.minutes() + 1 }, (_, i) => i);
                              }
                              return [];
                            },
                          };
                        }
                        return {};
                      }}
                    />
                  </label>
                ) : null}
                <label className="label" style={{ position: "relative" }}>
                  <PlanToast
                    available={["pro", "unlimited"]}
                    titleHeading={"End date"}
                  >
                    <p>End date</p>
                    <DatePicker
                      showNow={false}
                      type="datetime-local"
                      format={"DD/MM/YYYY hh:mm A"}
                      value={data.endTime ? moment(data.endTime) : null}
                      onChange={(value) => {
                        let obj = { ...data };
                        obj.endTime = value ? value.toISOString() : undefined;
                        setData(obj);
                      }}
                      disabledDate={(current) => {
                        if (setDate) {
                          let customDate =
                            moment(setDate).format("YYYY-MM-DD hh:mm");
                          return (
                            current &&
                            moment(customDate, "YYYY-MM-DD hh:mm") >
                            moment(current, "YYYY-MM-DD hh:mm")
                          );
                        } else {
                          let customDate = moment(new Date()).format(
                            "YYYY-MM-DD hh:mm"
                          );
                          return (
                            current &&
                            moment(customDate, "YYYY-MM-DD hh:mm") >
                            moment(current, "YYYY-MM-DD hh:mm")
                          );
                        }
                      }}
                      disabledTime={(current) => {
                        const now = moment();
                        if (current && current.isSame(now, 'day')) {
                          return {
                            disabledHours: () => Array.from({ length: now.hours() }, (_, i) => i),
                            disabledMinutes: () => {
                              // Disable all past minutes in the current hour
                              if (current.hours() === now.hours()) {
                                return Array.from({ length: now.minutes() + 1 }, (_, i) => i);
                              }
                              return [];
                            },
                          };
                        }
                        return {};
                      }}
                    />
                  </PlanToast>
                </label>
              </div>
            </div>

            <label className="label addNoteTextLabel">
              <PlanToast
                available={["pro", "unlimited"]}
                titleHeading={"Add note"}
              >
                <p style={{ marginTop: preRelease ? "20px" : "auto" }}>
                  Add note
                </p>
                <Input.TextArea
                  className="addNoteText"
                  placeholder="Write your notes here"
                  rows={4}
                  value={note}
                  onChange={(ev) => {
                    setNote(ev.target.value);
                  }}
                />
              </PlanToast>
            </label>
          </div>
          <div className="buttonDiv">
            <button
              className="addSong"
              disabled={(setLoading || isAccountPlaylistPickerLoading || !selectedPlayList?.length) ? true : false}
              onClick={() => addToPlaylistLoop()}
            >
              {setLoading ? <Spinner /> : "Add"}
            </button>
          </div>
        </div>
      </AddToPlayListModalStyle>
      <InstantShareModal
        isModalVisible={instantShareSongModal}
        setIsModalVisible={setInstantShareSongModal}
        editType={'viewDetail'}
        titleType={'scheduled'}
      />
    </>
  );
};

export default AddToPlayListModalSearch;
